"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _deprecatedPropType = _interopRequireDefault(require("@mui/utils/deprecatedPropType"));
var _default = exports.default = _deprecatedPropType.default;